export default "__VITE_ASSET__C8g72W1R__"